// ============================================================================
// view.activity — migrated off the global-read parity claim
// ============================================================================
// The global Activity timeline owns one cursor-paginated, authenticated RPC
// sequence. `activity.log.page` carries the full QueryScope and keeps each
// created_at cursor in TanStack Query page state, so a filter/retry sequence
// cannot append rows fetched for another subject, role, or filter.
//
// This declaration replaces legacy.all atomically. The independently checked
// receipt beside it records that durable ownership claim.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.activity',
  obligations: Object.freeze([Object.freeze({id: 'activity.log.page', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
